import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody2, TableBottom, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { AdminSaleMenu, onlyAdminSaleMenu, StkInwMenu } from '../TitleList';
import { selectAdminSaleData } from '../Selectors/Master/OutwardSelectors';
import { fetchAdminSaleData } from '../../Store/PHPSlice/stockApi';


const AdminSaleReg = () => {
    const dispatch = useDispatch();
    const getItems = useSelector(selectAdminSaleData);
    console.log("ietms=>",getItems);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    const [activeMenu, setActiveMenu] = useState(AdminSaleMenu);

    useEffect(() => {
        dispatch(fetchAdminSaleData());
    }, [dispatch]);

    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(onlyAdminSaleMenu);
                // console.log('hhi')
            } else {
                setActiveMenu(AdminSaleMenu);
            }

        }
    }, []);

    if (!getItems) {
        return <h1>Loading...</h1>;
    }

    // console.log(getItems);

    const compData = Array.isArray(getItems.data) ? getItems.data.map((item, index) => (
        {
            srNo: item.ID,
            dt: item.dt,
            billNo: item.billNo,
            zoneId: item.zoneId,
            zoneNm: item.zoneNm,
            schlId: item.schlId,
            schlNm: item.schlNm,
            stkId: item.stkId,
            totissqty: item.totissqty,
            totamt: item.totamt,
            sts: item.sts,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };


    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.billNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.zoneNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schlNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totissqty), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    return (
        <>
            <Titlebar data={activeMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Admin Sale Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'dt', label: 'Date' },
                                            { id: 'billNo', label: 'Bill No.' },
                                            { id: 'zoneNm', label: 'Zone' },
                                            { id: 'schlNm', label: 'School' },
                                            { id: 'totissqty', label: 'Total Qty' },
                                            { id: 'totprate', label: 'Total Amt.' },
                                            { id: '', label: 'Status' },
                                            { id: '', label: 'View' },
                                            { id: 'edit', label: 'Edit' },
                                            { id: 'add', label: 'Add Items' },
                                            { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody2
                                                key={row.srNo}
                                                id={row.srNo}
                                                dt={row.dt}
                                                billNo={row.billNo}
                                                zoneId={row.zoneId}
                                                zoneNm={row.zoneNm}
                                                schlId={row.schlId}
                                                schlNm={row.schlNm}
                                                stkId={row.stkId}
                                                totissqty={row.totissqty}
                                                totamt={row.totamt}
                                                sts={row.sts}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                        <TableBottom
                                            totamt={totamt}
                                            totqty={totqty}
                                        />
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default AdminSaleReg;
